import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from "axios";
import ValidationService from "@/services/ValidationService";
import {
  required,
  maxLength,
  integer,
  minValue,
  maxValue
} from "vuelidate/lib/validators";

export default {
  name: "FerryZoneList",
  components: {
    MainLayout,
    Loading,
  },
  mixins: [ValidationService],
  data() {
    return {
      isLoading: false,
      isEditMode: false,
      editId: null,
      currency: this.$store.state.setting.currency || '',
      zoneList: [],
      submitted: false,
      inputValidity: {
        ferry_price: false,
      },
      formData: {
        zone_name: "",
        ferry_price: "",
        desc: "",
      },
    };
  },
  validations: {
    formData: {
      zone_name: {
        required,
        maxLength: maxLength(255),
      },
      ferry_price: {
        required,
        integer,
        minValue: minValue(0),
        maxValue: maxValue(999999999),
      },
      desc: {
        maxLength: maxLength(1000),
      },
    },
  },
  methods: {
    clearValidationErrors() {
      this.validationErrors = {};
    },

    handleFerryPriceInput(event) {
      this.inputValidity.ferry_price = !!(event.target.validity && event.target.validity.badInput);
    },

    getZones() {
      this.isLoading = true;
      axios.get("ferry-zone/list")
        .then((res) => {
          this.zoneList = res.data;
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit("logout");
            window.location.replace("login");
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    resetForm() {
      this.clearValidationErrors();
      this.submitted = false;
      this.$v.$reset();
      this.isEditMode = false;
      this.editId = null;
      this.formData = {
        zone_name: "",
        ferry_price: "",
        desc: "",
      };
      this.inputValidity.ferry_price = false;
    },

    startEdit(zone) {
      this.clearValidationErrors();
      this.submitted = false;
      this.isEditMode = true;
      this.editId = zone.id;
      this.formData = {
        zone_name: zone.zone_name || "",
        ferry_price: zone.ferry_price ?? "",
        desc: zone.desc || "",
      };
      this.inputValidity.ferry_price = false;
      this.$nextTick(() => {
        this.$v.$reset();
      });
      window.scrollTo({ top: 0, behavior: "smooth" });
    },

    submit() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.isLoading = true;
      this.clearValidationErrors();

      const payload = {
        zone_name: this.formData.zone_name,
        ferry_price: this.formData.ferry_price,
        desc: this.formData.desc,
      };

      const request = this.isEditMode
        ? axios.put(`ferry-zone/update/${this.editId}`, payload)
        : axios.post("ferry-zone/create", payload);

      request
        .then((res) => {
          this.$notification.success(res.data.message, {
            timer: 3,
            position: "bottomCenter"
          });
          this.resetForm();
          this.getZones();
        })
        .catch((error) => {
          this.printValidationError(error.response);

          if (error.response && error.response.status == 401) {
            this.$store.commit("logout");
            window.location.replace("login");
            return;
          }

          if (error.response && error.response.status == 422) {
            const hasFieldErrors = Object.keys(this.validationErrors || {}).length > 0;
            if (!hasFieldErrors && error.response.data.message) {
              this.$notification.error(error.response.data.message, {
                timer: 3,
                position: "bottomCenter"
              });
            }
            return;
          }

          this.$notification.error(error.response?.data?.message || error.response?.data?.error || "Unable to save zone.", {
            timer: 3,
            position: "bottomCenter"
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    deleteZone(zone) {
      if (!confirm(`Delete ${zone.zone_name}?`)) {
        return;
      }

      this.isLoading = true;
      axios.delete(`ferry-zone/delete/${zone.id}`)
        .then((res) => {
          this.$notification.success(res.data.message, {
            timer: 3,
            position: "bottomCenter"
          });

          if (this.editId === zone.id) {
            this.resetForm();
          }

          this.getZones();
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit("logout");
            window.location.replace("login");
            return;
          }

          const message = error.response?.data?.message || "Unable to delete zone.";
          this.$notification.error(message, {
            timer: 3,
            position: "bottomCenter"
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  mounted() {
    this.getZones();
  }
};
